import React from "react";
import styled from "styled-components";
import Icon from "nekrasovka-ui/Icons";
import { useWindowDimensions } from "containers/WindowDimensions";
import Separator from "components/Separator";
import IconsGroup from "components/IconsGroup";

const SectionInner = styled.footer`
  background-color: #40677e;
  padding: 0 20px;
  margin-top: 60px;
`;

const Footer = styled.div`
  max-width: 1220px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;

  color: #edeee9;

  & p {
    font-family: Rubik, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #edeee9;
  }
`;

const SectionMain = styled.section`
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, auto);
  }

  @media (max-width: 568px) {
    grid-template-columns: 1fr;
    margin-top: 0;
  }

  * {
    font-family: Rubik, sans-serif;
    font-style: normal;
  }

  & > div > a {
    font-weight: bold;
  }

  & li {
    line-height: 35px;
  }

  & a {
    font-size: 14px;
    font-weight: normal;
  }
`;

const SectionBottom = styled.section`
  display: flex;
  margin-bottom: 40px;

  @media (max-width: 820px) {
    flex-direction: column;

    & > div {
      margin-left: 0 !important;
      margin-top: 30px;

      div:not(:last-child) {
        margin-right: 20px !important;
      }
    }
  }

  & p {
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
  }

  & > div {
    display: flex;
    margin-left: 90px;

    div:not(:last-child) {
      margin-right: 30px;
    }
  }
`;

const Logo = styled.div`
  & {
    display: flex;

    a svg {
      width: 170px;
      height: 54px;
    }

    @media (max-width: 768px) {
      a svg {
        width: 100px;
        height: 40px;
      }

      a:not(:last-child) {
        margin-right: 18px;
      }
    }

    @media (max-width: 568px) {
      width: 100%;
      justify-content: space-between;
      padding: 0;

      a {
        margin-right: 0 !important;

        svg {
          width: 87px;
          height: 31px;
          margin-right: 0 !important;
        }
      }
    }
  }
`;

export default () => {
  const { width } = useWindowDimensions();

  return (
    <SectionInner>
      <Footer>
        {width < 568 && (
          <IconsGroup iconsGroupStyle="margin-top: 30px; justify-content: center;" />
        )}
        {width < 569 && <Separator separatorStyle="margin: 30px 0;" />}
        <SectionMain>
          <div>
            <a href="https://nekrasovka.ru/articles/library">
              <span>О БИБЛИОТЕКЕ</span>
            </a>
            <ul>
              <li>
                <a href="https://nekrasovka.ru/articles/library/collection">
                  Фонды
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/library/history">
                  История
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/library/nekrasov">
                  Н.А. Некрасов
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/library/services">
                  Услуги
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/library/management">
                  Руководство
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/library/organization">
                  Структура и документы
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/library/contacts">
                  Как с нами связаться
                </a>
              </li>
            </ul>
          </div>
          <div>
            <a href="https://nekrasovka.ru/articles/guest">
              <span>ПОСЕТИТЕЛЯМ</span>
            </a>
            <ul>
              <li>
                <a href="https://nekrasovka.ru/articles/guest/rules">
                  Правила библиотеки
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/guest/account">
                  Личный кабинет
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/guest/resource">
                  Электронные ресурсы
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/guest/coworking">
                  Пространства для чтения и работы
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/guest/libraryservice">
                  Помощь библиографа
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/afisha">Культурные события</a>
              </li>

              <li>
                <a href="https://nekrasovka.ru/articles/guest/faq">
                  Ответы на вопросы
                </a>
              </li>
              <li>
                <a
                  href="http://bus.gov.ru/pub/independentRating/list"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Оценка качества услуг (bus.gov.ru)
                </a>
              </li>
              <li>
                <a
                  href="http://old.kultura.mos.ru/organizations/gbuk_gmoskvy_tsentralnaya_universalnaya_nauchnaya_biblioteka_imeni_nanekrasova.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Оценка качества услуг (mos.ru)
                </a>
              </li>
            </ul>
          </div>
          <div>
            <a href="https://nekrasovka.ru/articles/collegue">
              <span>КОЛЛЕГАМ</span>
            </a>
            <ul>
              <li>
                <a href="https://nekrasovka.ru/articles/education">
                  Образование
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/collegue/events">
                  События
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/collegue/materials">
                  Методические материалы
                </a>
              </li>
              <li>
                <a
                  href="http://miscp.ru"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Исследования
                </a>
              </li>
              <li>
                <a href="https://nekrasovka.ru/articles/collegue/forum">
                  Форум
                </a>
              </li>
            </ul>
          </div>
          {width > 568 && (
            <IconsGroup
              isLabelNeeded={true}
              iconsGroupStyle="flex-direction: column;align-items: flex-start; "
            />
          )}
        </SectionMain>
        {width > 568 && <Separator separatorStyle="margin: 30px 0" />}
        <SectionBottom>
          {width > 568 && (
            <p>
              Государственное бюджетное учреждение культуры города Москвы
              «Центральная универсальная научная библиотека имени Н.А.
              Некрасова»
            </p>
          )}
          <Logo>
            <a
              href={"https://nekrasovka.ru/"}
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Библиотека им. Н.А. Некрасова"
            >
              <Icon fill="#EDEEE9" icon={"logoFooterText"} />
            </a>
            <a
              href={"https://www.mos.ru/kultura/"}
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Департамент культуры города Москвы"
            >
              <Icon fill="#EDEEE9" icon={"logoDepMos"} />
            </a>
            <a
              href={"https://bibliogorod.ru/"}
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Библиотеки Москвы"
            >
              <Icon fill="#EDEEE9" icon={"logoBiblioText"} />
            </a>
          </Logo>
        </SectionBottom>
      </Footer>
    </SectionInner>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Footer/index.js